// <head> metadata for TermsOfServicePage (https://www.dbos.dev/terms-of-service).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Terms of Service | DBOS',
    },
    {
      property: 'og:title',
      content: 'Terms of Service | DBOS',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Terms of Service | DBOS',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/terms-of-service',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
